import { accordionIcon, floatPanelAccordionIcon } from './icons';

import { DEFAULT_CSS_CLASS } from '@constants';
const buttonBlockCssClass = DEFAULT_CSS_CLASS.ACCORDION;

const variations = [
  {
    name: 'default-accordion',
    title: 'Default Accordion',
    icon: accordionIcon,
    innerBlocks: [['b3rg/accordion-item', {}]],
    attributes: {
      blockClassNames: [
        {
          value: `${buttonBlockCssClass}--dlt`,
          label: 'Dlt',
        },
      ],
    },
    scope: ['block'],
  },
  {
    name: 'float-panel-accordion',
    title: 'Accordion with Floating Panels',
    icon: floatPanelAccordionIcon,
    innerBlocks: [['b3rg/accordion-item', {}]],
    attributes: {
      floatPanel: true,
      blockClassNames: [
        {
          value: `${buttonBlockCssClass}--dlt`,
          label: 'Dlt',
        },
      ],
    },
    scope: ['block'],
  },
];

export default variations;
